import React from "react"

export const DirectionIcon = ({ height = 24, width = 24, fill = "currentColor", ...props }) => (
 <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none" {...props}>
<path d="M3 11L22 2L13 21L11 13L3 11Z" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
)
